import NotificationService from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/services/NotificationService";
import { DocumentCenterFile } from "@/models/DocumentCenterFile";
import { LazoFile } from "@/models/LazoFile";
import DocumentCenterFileService from "@/services/DocumentCenterFileService";
import LazoFileService from "@/services/LazoFileService";

export const download = (blob: Blob, name: string) => {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.style.display = "none";
  a.href = url;
  a.download = name;
  document.body.appendChild(a);
  a.click();
  window.URL.revokeObjectURL(url);
  document.body.removeChild(a);
  return;
};

export const downloadManyDeliverableFiles = async (filesToDownload: LazoFile[]) => {
  const content = await LazoFileService.downloadFileWithoutSave(filesToDownload.map(({ externalId }) => externalId));
  return download(content, "deliverables.zip");
};

export const downloadManyDocumentFiles = async (filesToDownload: DocumentCenterFile[]) => {
  try {
    const content = await DocumentCenterFileService.downloadMany(filesToDownload.map((f) => f.externalId));
    if (typeof content === "string") {
      const filename = filesToDownload.length === 1 ? filesToDownload[0].name : "documents.zip";
      DocumentCenterFileService.downloadUrl(content, filename);
      return;
    }
    return download(content, "documents.zip");
  } catch (error: any) {
    const errorMessage = error?.message || error?.toString() || "Unknown error";
    NotificationService.error(errorMessage);
    throw error;
  }
};
